import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import cx from 'classnames';
import styles from './styles.scss';

function Spinner() {
  return (
    <div
      id="spinner"
      className={cx(styles.spinner)}
    >
      <CircularProgress thickness={8} color="inherit" size={80} variant="indeterminate" />
    </div>
  );
}

export default withStyles(styles)(Spinner);
